import React, { useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import ImageGrid from './ImageGrid';
import CarouselView from './CarouselView';
import Lightbox from './Lightbox';

const GalleryViewer = ({ currentCategory, isGridView }) => {
  const [selectedImage, setSelectedImage] = useState(null);

  const handleImageClick = (item) => {
    if (item.type === 'video') {
      // For videos, open in new tab or handle video playback
      window.open(item.src, '_blank');
    } else {
      // For images, open in lightbox
      setSelectedImage(item);
    }
  };

  const handleMediaClick = (item) => {
    setSelectedImage(item);
  };

  return (
    <>
      <AnimatePresence mode="wait">
        {isGridView ? (
          <ImageGrid 
            key={`grid-${currentCategory.id}`}
            images={currentCategory.images} 
            categoryColor={currentCategory.color}
            onImageClick={handleMediaClick}
          />
        ) : (
          <CarouselView 
            key={`carousel-${currentCategory.id}`}
            images={currentCategory.images}
            categoryColor={currentCategory.color}
            onImageClick={handleMediaClick}
          />
        )}
      </AnimatePresence>

      <Lightbox 
        selectedImage={selectedImage} 
        images={currentCategory.images} 
        onClose={() => setSelectedImage(null)} 
      />
    </>
  );
};

export default GalleryViewer;